import { colors } from "../../styles/colors";
import { createUseStyles } from "react-jss";

type Props = {
  width?: string | number;
};

const useStyles = createUseStyles(() => ({
  containerDialog: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      width: (props: Props) => (props.width ? props.width : "383px"),
      // Never exceed the viewport; account for the dialog's own side margins.
      maxWidth: "calc(100vw - 32px)",
      borderRadius: "15px",
      padding: "20px",
      border: `1px solid ${colors.borderLight}`,
      // Tighten margins on small screens so the modal isn't cramped.
      "@media (max-width:599.95px)": {
        margin: "16px",
        padding: "16px",
      },
    },
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    flexWrap: "wrap",
    // Stack action buttons on very narrow screens for comfortable tap targets.
    "@media (max-width: 420px)": {
      flexDirection: "column-reverse",
      "& > *": {
        width: "100% !important",
      },
    },
  },
}));

export default useStyles;
